import React from "react";
import renderIf from "../../utils/renderIf";
import locale from "../../utils/locale";
import Icon from "@material-ui/core/Icon";

const InfoIcon = ({ onHelpClick, hideIcon, hideText }) => (
  <div>
    {!hideIcon ? (
      <div>
        <Icon onClick={onHelpClick}>{locale("info")}</Icon>
      </div>
    ) : (
      ""
    )}
    {!hideText ? <div>{locale("partnershipText")}</div> : ""}

  </div>
);

export default InfoIcon;




// WEBPACK FOOTER //
// ./src/components/Header/InfoIcon.js